import React, { useState } from "react";
import { Button } from "semantic-ui-react";
import { ConfirmModal } from "ceco-modal";
import graphql from "babel-plugin-relay/macro";
import { toast } from "react-toastify";
import { commitMutation } from "react-relay";
import environment from "../../../environment";
import { useTranslation } from "ceco-polyglot";

export default function IngredientRecipeDeleteModal(props) {
  const { trigger, ingredient, recipeName, refetchData } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState();

  const t = useTranslation();
  function deleteIngredientToRecipe() {
    return new Promise((resolve, reject) => {
      const variables = {
        ...formData,
      };
      commitMutation(environment, {
        mutation: ingredientRecipeModal_delete_Mutation,
        variables,
        onCompleted(response, errors) {
          if (errors) {
            reject(errors);
          }
          resolve(response);
        },
        onError(error) {
          reject(error);
        },
      });
    });
  }

  const onSubmit = async () => {
    setLoading(true);
    deleteIngredientToRecipe()
      .then((a) => {
        toast.success(t("message.deleted_ingredient"));
        setModalOpen(false);
        setLoading(false);
        refetchData();
      })
      .catch((e) => {
        setLoading(false);

        if (Array.isArray(e)) {
          toast.error(e[0].message);
        } else {
          toast.error(e.errors[0].message);
        }
      });
  };
  return (
    <ConfirmModal
      modalOpen={modalOpen}
      title={t("modalTitle.removeIngredient")}
      trigger={React.cloneElement(trigger, {
        onClick: (e) => {
          e.preventDefault();
          setModalOpen(true);

          setFormData({ id: ingredient.id });
        },
      })}
      onClose={() => setModalOpen(false)}
      showCloseButton={true}
      description={
        <div>
          {t("warning.ingredient_remove", {
            ingredientName: ingredient.ingredient.name,
            recipeName: recipeName,
          })}
        </div>
      }
      renderActions={() => (
        <div>
          <Button
            disabled={loading}
            color="red"
            onClick={() => {
              onSubmit();
            }}
          >
            {t("action.delete")}
          </Button>
          <Button
            color="green"
            onClick={() => {
              setModalOpen(false);
            }}
          >
            {t("action.cancel")}
          </Button>
        </div>
      )}
    />
  );
}
const ingredientRecipeModal_delete_Mutation = graphql`
  mutation IngredientRecipeDeleteModalMutation($id: ID!) {
    recipeIngredientDelete(input: { id: $id }) {
      deleted
    }
  }
`;
